import { differenceInCalendarDays } from 'date-fns';
import { IActivityGroup } from '@/redux/activity/activity.d';

export interface FeedSection {
  label: string;
  groups: IActivityGroup[];
}

const BUCKETS: { label: string; maxDays: number }[] = [
  { label: 'Today', maxDays: 0 },
  { label: 'Yesterday', maxDays: 1 },
  { label: 'Last 7 days', maxDays: 6 },
  { label: 'Last 30 days', maxDays: 29 },
  { label: 'Older', maxDays: Infinity },
];

const AGE_UNITS: [string, number][] = [
  ['y', 365 * 86400],
  ['w', 7 * 86400],
  ['d', 86400],
  ['h', 3600],
  ['m', 60],
];

/** Compact age, like "2h" or "3w". */
export function shortAge(createdAt: string, now = Date.now()): string {
  const seconds = Math.max(0, (now - new Date(createdAt).getTime()) / 1000);
  const unit = AGE_UNITS.find(([, size]) => seconds >= size);
  return unit ? `${Math.floor(seconds / unit[1])}${unit[0]}` : 'now';
}

const bucketFor = (createdAt: string, now: Date) => {
  const days = differenceInCalendarDays(now, new Date(createdAt));
  return BUCKETS.find((bucket) => days <= bucket.maxDays)!.label;
};

/** Groups arrive newest first, so each bucket is one contiguous run. */
export function groupByAge(
  groups: IActivityGroup[],
  now = new Date()
): FeedSection[] {
  return groups.reduce<FeedSection[]>((sections, group) => {
    const label = bucketFor(group.latestAt, now);
    const last = sections[sections.length - 1];
    if (last?.label === label) last.groups.push(group);
    else sections.push({ label, groups: [group] });
    return sections;
  }, []);
}
